import { render, staticRenderFns } from "./BaseButtonWhite.vue?vue&type=template&id=9b0696f2&"
import script from "./BaseButtonWhite.vue?vue&type=script&lang=js&"
export * from "./BaseButtonWhite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports